module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-140.faf426d.woff2";